<template>
    <v-alert v-if="props.show" prominent type="info" color="grey" variant="tonal" class="mt-3">
        <slot>{{ props.message }}</slot>
    </v-alert>
</template>
<script setup lang="ts">
    export interface Props {
        show: boolean
        message?: string
    }

    const props = withDefaults(defineProps<Props>(), {
        message: ''
    })
</script>
